import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CONTENT_PREVIEWS } from '../lib/data';
export function ContentPreviewCarousel() {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const goToSlide = (index: number) => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    carousel.scrollTo({
      left: carousel.clientWidth * index,
      behavior: 'smooth'
    });
    setActiveIndex(index);
  };
  const handleScroll = () => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
    setActiveIndex(Math.min(Math.max(index, 0), CONTENT_PREVIEWS.length - 1));
  };
  return <section className="py-8" aria-label="Vista previa del contenido del sistema" data-id="element-97" data-mp="1wex6npemu7be">
      <h2 className="mb-5 px-4 text-center font-display text-2xl leading-tight text-white" data-id="element-98" data-mp="21drlyhde5dqr">
        Echa un vistazo al contenido
      </h2>

      <div className="relative w-full" data-id="element-99" data-mp="2023otrryuqdr">
        <div ref={carouselRef} onScroll={handleScroll} className="no-scrollbar flex w-full snap-x snap-mandatory overflow-x-auto" aria-roledescription="carrusel" data-id="element-100" data-mp="1zyy1agyzjwk5">
          {CONTENT_PREVIEWS.map((preview, index) => <figure key={preview.src} className="w-full min-w-full snap-center" data-id="element-101" data-mp="1m2ksrxcfj5ht" data-mpi={index}>
              <img src={preview.src} alt={preview.alt} loading={index === 0 ? 'eager' : 'lazy'} className="block h-auto w-full" data-id="element-102" data-mp="2irs64i2wa8an" />
            </figure>)}
        </div>

        <button type="button" onClick={() => goToSlide((activeIndex - 1 + CONTENT_PREVIEWS.length) % CONTENT_PREVIEWS.length)} aria-label="Ver contenido anterior" className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-black/65 text-white backdrop-blur transition-colors hover:bg-black/85" data-id="element-103" data-mp="29wvm0uhmzb80">
          <ChevronLeftIcon className="h-5 w-5" data-id="element-104" data-mp="3gn4hojnyb4qz" />
        </button>
        <button type="button" onClick={() => goToSlide((activeIndex + 1) % CONTENT_PREVIEWS.length)} aria-label="Ver contenido siguiente" className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-black/65 text-white backdrop-blur transition-colors hover:bg-black/85" data-id="element-105" data-mp="3litbe6dahrfd">
          <ChevronRightIcon className="h-5 w-5" data-id="element-106" data-mp="32u689teobc4f" />
        </button>
      </div>

      <div className="mt-3 flex items-center justify-center gap-1.5" aria-label="Seleccionar vista previa" data-id="element-107" data-mp="2otvfulxptph5">
        {CONTENT_PREVIEWS.map((preview, index) => <button key={preview.src} type="button" onClick={() => goToSlide(index)} aria-label={`Mostrar vista previa ${index + 1}`} aria-current={activeIndex === index ? 'true' : undefined} className={`h-2 rounded-full transition-[width,background-color] duration-200 ${activeIndex === index ? 'w-5 bg-hockey-pink' : 'w-2 bg-white/30'}`} data-id="element-108" data-mp="2svz1u4i0gcgo" data-mpi={index} />)}
      </div>
      <p className="mt-2 text-center text-[11px] text-white/40" data-id="element-109" data-mp="2lc7t35rjpjfh">Desliza para explorar las páginas incluidas</p>
    </section>;
}